<div class="login-box">
  <div class="login-logo">
    <img height="80" src="{{logoPath}}" />
  </div>
  <div class="login-box-body" *ngIf="shouldShowLogin">
    <div class="alert alert-danger" role="alert" *ngIf="isNotProduction">
      <p class="mb-0">ATENÇÃO: ESTE É UM AMBIENTE DE TESTE. NÃO EXECUTE OPERAÇÕES REAIS.</p>
    </div>
    <form [formGroup]="login">
      <div
        class="has-feedback mb-2"
        [class.has-error]="username.invalid && username.dirty"
      >
        <input
          type="text"
          data-cy="login"
          class="form-control"
          placeholder="Usuário"
          formControlName="username"
        />
        <span class="glyphicon glyphicon-envelope form-control-feedback"></span>
        <div class="help-block" [hidden]="username.valid || username.pristine">
          Usuário inválido
        </div>
      </div>
      <div
        class="has-feedback mb-1"
        [class.has-error]="password.invalid && password.dirty"
      >
        <input
          type="password"
          data-cy="password"
          class="form-control"
          placeholder="Senha"
          formControlName="password"
        />
        <span class="glyphicon glyphicon-lock form-control-feedback"></span>
        <div
          class="help-block"
          [hidden]="!password.hasError('required') || password.pristine"
        >
          Senha inválida
        </div>
        <div
          class="help-block"
          [hidden]="!password.hasError('minlength') || password.pristine"
        >
          A senha precisa ter no mínimo 8 caracteres
        </div>
      </div>
      <div class="d-flex justify-content-end mb-3">
        <a href="/esqueci-senha">Esqueci minha senha</a>
      </div>
      <div class="d-flex justify-content-center">
        <button
          data-cy="submit"
          class="btn btn-primary btn-block btn-flat mb-3"
          (click)="signin()"
          [disabled]="isAuthenticating"
        >
          Entrar
        </button>
      </div>
    </form>
  </div>
  <div *ngIf="!shouldShowLogin && !has2fa" class="mb-5 login-box-body">
    <div
      class="w-full p-3 text-xl flex align-items-center text-center"
    >
      <qrcode
        *ngIf="
          generate2FAReturnModel.path != null &&
          generate2FAReturnModel.path != ''
        "
        [allowEmptyString]="true"
        [qrdata]="generate2FAReturnModel.path"
        [width]="250"
        [errorCorrectionLevel]="'M'"
      ></qrcode>
    </div>
    <div
      class="w-full p-3 text-xl flex align-items-center text-center"
    >
      <label for="codeQr"><b>Código QR</b></label>
    </div>
    <div
      class="w-full text-xl flex align-items-center text-center"
    >
      {{ generate2FAReturnModel.code }}
      <a (click)="copyCode()">
        <i
          title="Copiar Código QR"
          class="fa fa-lg fa-copy"
          style="font-size: 1.3rem"
        ></i>
      </a>
    </div>
    <div class="mt-3 w-full md:w-10 mx-auto">
      <div class="text-center mb-2">
        <p>
          <strong
            >ATENÇÃO! CASO NÃO COMPLETE AGORA A LIBERAÇÃO DO DUPLO
            AUTENTICADOR, SERÁ NECESSÁRIO FAZER CONTATO SOLICITANDO A
            REDEFINIÇÃO DA CHAVE AUTENTICADORA.</strong
          >
        </p>
        <p>
          Para dar continuidade à implementação da dupla autenticação
          baixe um autenticador da sua preferência (sugerimos o Google
          Authenticator ou o Microsoft Authenticator). Será necessário
          fazer o download na loja de aplicativos do seu celular.
        </p>
        <p>
          Dentro do aplicativo, procure pelo leitor de QrCode e leia o
          QrCode acima para configurar a dupla autenticação.
        </p>
      </div>
      <div class="d-flex justify-content-center mb-5">
        <button
          class="btn btn-primary btn-block btn-flat mb-3"
          (click)="continue()"
        >Continuar</button>
      </div>
    </div>
  </div>
  <div *ngIf="!shouldShowLogin && has2fa" class="login-box-body">
    <label for="code" class="mb-2">Digite o código que é mostrado no seu aplicativo Autenticador!</label>
    <input
      type="text"
      data-cy="code"
      class="form-control"
      placeholder="Código"
      [(ngModel)]="credentials.code"
      (keyup.enter)="sendCode()"
    />
    <div class="d-flex justify-content-center mt-3">
      <button
        class="btn btn-primary btn-block btn-flat mb-3"
        (click)="sendCode()"
        [disabled]="sendCodeDisabled()"
      >Enviar</button>
    </div>
  </div>
</div>
